// Bộ định tuyến 30 dòng bằng hash (#/caidat/ngay-le) — không cần thư viện (SKILL §5.6), chạy được trên Cloudflare Pages tĩnh
// mà không phải cấu hình chuyển hướng. Luật đọc / ghi đường dẫn ở core/voApp.ts (có test).
import { useSyncExternalStore } from "react";
import { type DuongDan, docDuongDan, taoDuongDan } from "../core/voApp";

const nghe = (cb: () => void) => {
  window.addEventListener("hashchange", cb);
  return () => window.removeEventListener("hashchange", cb);
};
const chup = () => window.location.hash;

export function useDuongDan(): DuongDan {
  const hash = useSyncExternalStore(nghe, chup, () => "");
  return docDuongDan(hash);
}

export function dieuHuong(d: DuongDan, thay = false) {
  const moi = taoDuongDan(d);
  if (moi === window.location.hash) return;
  if (thay) {
    history.replaceState(null, "", moi);
    window.dispatchEvent(new HashChangeEvent("hashchange"));
  } else {
    window.location.hash = moi;
  }
}
